import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cps-session-expired-modal',
  templateUrl: './cps-session-expired-modal.component.html',
  styleUrls: ['./cps-session-expired-modal.component.scss']
})
export class CpsSessionExpiredModalComponent implements OnInit {

  constructor(private cd: ChangeDetectorRef, public bsModalRef: BsModalRef, private router: Router) { }

  ngOnInit(): void {
    // Empty
  }

  detectChanges(): void {
    this.cd.detectChanges();
  }

  buttonClick(): void {
    this.bsModalRef.hide();
    this.router.navigate(['/login']);
  }

}
